// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"49692fe8","453":"cdd01287"}[chunkId] + ".chunk.js";
};